/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const FormErrors = zod
	.object({
		errors: zod.record(zod.string(), zod.array(zod.string()))
	})
	.describe('Field validation errors');

export type FormErrors = zod.input<typeof FormErrors>;
export type FormErrorsOutput = zod.output<typeof FormErrors>;
